'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import type { SegmentPageInfo } from '@fff-web/segment';
import { trackPage } from '../../_lib/segment';

type PageViewProps = {
  pageConfig: SegmentPageInfo;
};

export const PageView = ({ pageConfig }: PageViewProps) => {
  const pathname = usePathname();

  useEffect(() => {
    /**
     * Track page view. If you need to send additional properties,
     * for a specific page event, you can do so by enriching the
     * context here and send it along with the `sessionInfo`.
     */
    trackPage(pathname, { ...pageConfig, path: pathname, url: window.location.href });
  }, [pathname, pageConfig]);

  return null;
};
